// SEO landing pages — keyword + location clusters for the African IT/ISP market.
export const LANDINGS = [
  {
    "slug": "it-solutions-company-kampala-uganda",
    "metaTitle": "IT Solutions Company in Kampala, Uganda | Jero-One Technologies",
    "metaDescription": "Jero-One Technologies is an IT solutions company in Kampala & Entebbe, Uganda: networking, cybersecurity, cloud, CCTV, computers and managed IT support.",
    "keywords": "IT solutions company Kampala, IT company Uganda, IT services Entebbe, managed IT Uganda, IT support Kampala, computer supplier Uganda",
    "kicker": "IT Solutions · Kampala & Entebbe",
    "h1": "IT Solutions Company in Kampala, Uganda.",
    "intro": "From our office in Downtown Entebbe, Jero-One Technologies delivers complete IT solutions to businesses, banks, schools, NGOs and government across Kampala and Uganda: hardware supply, networks, security, cloud and ongoing managed support, backed by our global team in Minnesota and Canada.",
    "serviceType": "IT Solutions Provider",
    "offerings": [
      "IT hardware supply: HP, Dell, Lenovo, Cisco, Ubiquiti",
      "Network design, structured cabling & fibre",
      "Cybersecurity, Fortinet firewalls & SD-WAN",
      "Cloud, Microsoft 365 & data backup",
      "CCTV, access control & conference rooms",
      "Managed IT support & maintenance contracts"
    ],
    "why": [
      "Global IT company founded in 2009, serving Uganda since 2016",
      "Certified engineers and genuine manufacturer products",
      "One partner for supply, installation and support",
      "Transparent USD/UGX pricing and fast quotations"
    ],
    "faq": [
      {
        "q": "Where is Jero-One Technologies located in Uganda?",
        "a": "Our Uganda office is in Downtown Entebbe (P.O. Box 171736, Kampala GPO) and we serve clients throughout Kampala, Entebbe and the rest of Uganda."
      },
      {
        "q": "What IT services do you offer in Kampala?",
        "a": "Hardware supply, networking, cybersecurity, cloud and Microsoft 365, CCTV, conference rooms, IT training and managed IT support."
      },
      {
        "q": "How do I get a quotation?",
        "a": "Use Request a Quote in our online shop, call +256 766 553 449, or email info@jero-onetechnologies.com. We usually respond within one business day."
      }
    ],
    "image": "/website-assets/images/svc-consulting-900x600.jpg"
  },
  {
    "slug": "cybersecurity-kampala-uganda",
    "metaTitle": "Enterprise Cybersecurity & Network Setup Entebbe | Jero-One",
    "metaDescription": "Enterprise cybersecurity in Kampala & Entebbe: Fortinet firewalls, SOC monitoring, penetration testing, endpoint protection and secure network setup.",
    "keywords": "cybersecurity Kampala, cybersecurity company Uganda, network security Entebbe, firewall installation Uganda, SOC Uganda, penetration testing Kampala",
    "kicker": "Cybersecurity · Uganda",
    "h1": "Enterprise Cybersecurity & Network Setup in Entebbe & Kampala.",
    "intro": "Ransomware, phishing and data breaches are rising across East Africa. Jero-One Technologies protects banks, SACCOs, schools, hospitals and government institutions with layered security: Fortinet next-generation firewalls, 24/7 monitoring, endpoint protection and staff awareness training.",
    "serviceType": "Cybersecurity Services",
    "offerings": [
      "Fortinet FortiGate firewall design & installation",
      "24/7 security monitoring (SOC) & alerting",
      "Vulnerability assessments & penetration testing",
      "Endpoint protection, backup & ransomware recovery",
      "Email security, MFA & Microsoft 365 hardening",
      "Uganda Data Protection & Privacy Act compliance support"
    ],
    "why": [
      "Fortinet and VeloCloud solutions partner",
      "Experience with financial institutions and government",
      "Clear reports with prioritised fixes",
      "Local engineers with global expertise"
    ],
    "faq": [
      {
        "q": "How much does cybersecurity cost for a business in Uganda?",
        "a": "It depends on users, sites and the level of monitoring. A small office firewall and endpoint package is very different from a multi-branch bank. We provide a free assessment and a fixed quotation."
      },
      {
        "q": "What are the implementation steps?",
        "a": "1) Free security assessment, 2) design and quotation, 3) firewall and endpoint deployment, 4) policies and staff training, 5) ongoing monitoring and monthly reports."
      },
      {
        "q": "Do you help with data protection compliance?",
        "a": "Yes. We help organisations meet the Uganda Data Protection and Privacy Act with access controls, encryption, logging, backups and documentation."
      }
    ],
    "image": "/website-assets/images/svc-cyber-900x600.jpg"
  },
  {
    "slug": "managed-it-services-minnesota",
    "phone": "+1 682-461-4255",
    "metaTitle": "Managed IT & Cloud Services Minnesota | Jero-One Technologies",
    "metaDescription": "Managed IT and cloud services in Minnesota from Jero-One Technologies, Eden Prairie: help desk, Microsoft 365, AWS/Azure, cybersecurity and hardware.",
    "keywords": "managed IT services Minnesota, managed cloud services Minnesota, IT support Eden Prairie, IT company Minneapolis, Microsoft 365 support Minnesota",
    "kicker": "Managed IT · Minnesota, USA",
    "h1": "Managed IT & Cloud Services in Minnesota.",
    "intro": "Our headquarters in Eden Prairie, Minnesota supports small and mid-size businesses across the Twin Cities and North America with predictable monthly IT: proactive monitoring, help desk, Microsoft 365, AWS and Azure cloud management, security and hardware lifecycle.",
    "serviceType": "Managed IT Services",
    "offerings": [
      "24/7 monitoring & help-desk support",
      "Microsoft 365 & Google Workspace administration",
      "AWS & Azure cloud migration and management",
      "Managed firewall, endpoint & backup",
      "Hardware procurement & lifecycle (HP, Dell, Lenovo)",
      "IT strategy & vCIO consulting"
    ],
    "why": [
      "Minnesota headquarters of a global IT company founded in 2009",
      "Predictable flat monthly pricing",
      "Security-first approach",
      "Same team serving US, Canada and East Africa"
    ],
    "faq": [
      {
        "q": "What does managed IT cost in Minnesota?",
        "a": "Plans are priced per user or per device per month depending on coverage. We provide a free assessment and a fixed proposal."
      },
      {
        "q": "Can you migrate us to the cloud?",
        "a": "Yes. We plan and execute migrations to Microsoft 365, AWS and Azure with minimal downtime, then manage costs and security."
      },
      {
        "q": "Do you offer on-site support?",
        "a": "Yes. On-site support is available in the Minneapolis–St. Paul area, with remote support everywhere."
      }
    ],
    "image": "/website-assets/images/svc-managed-900x600.jpg"
  },
  {
    "slug": "fortinet-sd-wan-firewall-uganda",
    "metaTitle": "Fortinet Firewall & VeloCloud SD-WAN Uganda | Jero-One",
    "metaDescription": "Fortinet FortiGate firewalls and VeloCloud SD-WAN in Uganda: design, licensing, installation and 24/7 managed service for branches, banks and schools.",
    "keywords": "Fortinet Uganda, FortiGate Kampala, SD-WAN Uganda, VeloCloud Uganda, firewall supplier Uganda, SASE East Africa",
    "kicker": "Secure Networks · Fortinet & VeloCloud",
    "h1": "Fortinet Firewalls & VeloCloud SD-WAN in Uganda.",
    "intro": "Connect your head office, branches and cloud apps securely. Jero-One designs, supplies, licenses and manages Fortinet FortiGate next-generation firewalls and VeloCloud SD-WAN edges, combining fibre, broadband and 4G/5G into one resilient, secure network.",
    "serviceType": "Network Security & SD-WAN",
    "offerings": [
      "FortiGate 40F–200F next-generation firewalls",
      "FortiGuard UTP licensing (1, 3, 5 years)",
      "VeloCloud SD-WAN Edge 510–680",
      "Multi-ISP failover & application-aware routing",
      "Zero-touch branch deployment",
      "24/7 managed monitoring & support"
    ],
    "why": [
      "Fortinet and VeloCloud solutions partner",
      "Experience with multi-branch banks and NGOs",
      "Vendor-certified configuration",
      "Local support in Kampala & Entebbe"
    ],
    "faq": [
      {
        "q": "How much does a FortiGate firewall cost in Uganda?",
        "a": "Pricing depends on the model, licence bundle and term. Request a quote and we size the right FortiGate for your users and bandwidth."
      },
      {
        "q": "What is SD-WAN?",
        "a": "SD-WAN combines several internet links into one smart network that steers traffic automatically, so a failed link doesn't take your branch offline."
      },
      {
        "q": "Can you manage it for us?",
        "a": "Yes, with monthly managed service plans including monitoring, updates and support."
      }
    ],
    "image": "/website-assets/images/svc-sdwan-firewall-900x600.jpg"
  },
  {
    "slug": "conference-room-smart-boards-uganda",
    "metaTitle": "Interactive Boards & Conference Rooms Uganda | Jero-One",
    "metaDescription": "Interactive smart boards, video-conferencing and e-learning room installation in Uganda: BenQ, Barco ClickShare, Yealink, Zoom Rooms and Microsoft Teams.",
    "keywords": "interactive boards Uganda, smart board Kampala, conference room setup Uganda, video conferencing Kampala, e-learning classroom Uganda, Barco ClickShare Uganda",
    "kicker": "AV & Conferencing · Uganda",
    "h1": "Interactive Boards & Conference Room Installation in Uganda.",
    "intro": "We install and manage complete smart-board and video-conferencing rooms for boardrooms, training centres and e-learning classrooms: 4K interactive displays, wireless presentation, conferencing cameras, microphones and speakers, fully cabled, programmed and handed over with training.",
    "serviceType": "Audio Visual Installation",
    "offerings": [
      "BenQ 4K interactive displays",
      "Barco ClickShare wireless presentation",
      "Zoom Rooms / Microsoft Teams Rooms with Intel NUC",
      "Yealink cameras & conference consoles",
      "JBL speakers & Bosch mixer-amplifiers",
      "Cabling, commissioning, training & support"
    ],
    "why": [
      "Turnkey design, supply and installation",
      "Works with Teams, Zoom and Google Meet",
      "Clean concealed cabling",
      "Ongoing support and maintenance"
    ],
    "faq": [
      {
        "q": "How much does a smart conference room cost?",
        "a": "A complete room with a 75\" 4K interactive display, ClickShare, room PC, camera, console, speakers and installation is quoted per room; see individual prices in our shop or request a quote."
      },
      {
        "q": "Can it be used for e-learning?",
        "a": "Yes. Interactive whiteboarding, lesson recording and remote students are supported."
      },
      {
        "q": "Do you provide training?",
        "a": "Yes, user training and handover documentation are included."
      }
    ],
    "image": "/website-assets/images/svc-conference-room-900x600.jpg"
  },
  {
    slug: "internet-isp-uganda",
    metaTitle: "Fast Internet & ISP Services in Uganda | Jero-One Technologies",
    metaDescription:
      "Looking for a reliable ISP in Uganda? Jero-One Technologies delivers fast business internet, fibre, Wi-Fi, LAN/WAN and dedicated connectivity across Uganda, Kampala, Entebbe & East Africa. Get connected today.",
    keywords:
      "ISP Uganda, internet service provider Uganda, fast internet Kampala, business internet Uganda, fibre internet Uganda, dedicated internet East Africa, Wi-Fi installation Uganda, LAN WAN setup Uganda, best ISP Uganda",
    kicker: "Internet & Connectivity",
    h1: "Fast, reliable internet & ISP services in Uganda & East Africa.",
    intro:
      "Jero-One Technologies is your trusted internet and connectivity partner in Uganda. Whether you need fast business fibre, dedicated bandwidth, office Wi-Fi, or full LAN/WAN network setup, we design, install and support connections that keep your business online — in Kampala, Entebbe and across East Africa.",
    serviceType: "Internet Service Provider",
    offerings: [
      "High-speed business fibre & broadband internet",
      "Dedicated & guaranteed-bandwidth links for offices",
      "Office & campus Wi-Fi design and installation",
      "Structured cabling, LAN, WAN & VPN setup",
      "Point-to-point & last-mile connectivity",
      "Network monitoring, uptime & priority support",
    ],
    why: [
      "Trusted ISP and network integrator since 2016",
      "Enterprise-grade Cisco, MikroTik & Ubiquiti hardware",
      "Fast installation and responsive local support",
      "Coverage across Uganda & East Africa",
    ],
    faq: [
      { q: "Do you provide internet for businesses in Kampala and Entebbe?", a: "Yes. We deliver fast, reliable business internet, fibre and Wi-Fi across Kampala, Entebbe and the greater Uganda region, with support extending into East Africa." },
      { q: "Can you set up office Wi-Fi and networks?", a: "Absolutely. We handle end-to-end network design — structured cabling, routers, switches, access points, LAN/WAN and VPN — for offices, hotels, schools and campuses." },
      { q: "What internet speeds can I get?", a: "We tailor bandwidth to your needs, from small-office broadband to dedicated high-capacity fibre links for enterprises and data centres." },
    ],
    image: "/legacy/router.jpg",
  },
  {
    slug: "laptops-computers-uganda",
    metaTitle: "Buy Laptops, Computers, RAM & IT Hardware in Uganda | Jero-One",
    metaDescription:
      "Buy genuine laptops, desktops, servers, RAM, SSDs and IT hardware in Uganda. Jero-One Technologies supplies Dell, HP, Lenovo, Apple & more with warranty, delivery and on-site setup across Uganda & East Africa.",
    keywords:
      "buy laptops Uganda, computers Kampala, business laptops Uganda, buy RAM Uganda, SSD hard drives Uganda, servers Uganda, Dell HP Lenovo Uganda, IT hardware supplier Uganda, desktop computers East Africa, new and refurbished laptops Uganda, refurbished computers Uganda, used laptops Kampala",
    kicker: "Hardware Supply",
    h1: "Buy new & refurbished laptops, computers, RAM & hardware in Uganda.",
    intro:
      "Need reliable computers or upgrades? Jero-One Technologies supplies both brand-new and certified refurbished laptops, desktops, enterprise servers, RAM, SSDs, hard drives and accessories in Uganda. We supply trusted brands — Dell, HP, Lenovo, Apple, HPE and more — with warranty, delivery and professional on-site setup across Uganda, East Africa and our USA (Minnesota) office.",
    serviceType: "Computer Store",
    offerings: [
      "New & certified refurbished laptops and desktops",
      "Enterprise servers & workstations (new & refurbished)",
      "RAM, SSDs, hard drives & memory upgrades",
      "Monitors, printers, scanners & peripherals",
      "Custom-built PCs to your specification",
      "Bulk supply for offices, schools & government",
    ],
    why: [
      "Both new and budget-friendly refurbished options",
      "Genuine, warrantied hardware from top brands",
      "Delivery + on-site installation & configuration",
      "Trusted IT supplier since 2016 (Uganda & USA)",
    ],
    faq: [
      { q: "Do you sell new and refurbished laptops in Uganda?", a: "Yes — we supply both brand-new and certified refurbished laptops, desktops, servers and components from Dell, HP, Lenovo, Apple and more, all with warranty and delivery across Uganda and East Africa." },
      { q: "Are refurbished computers reliable?", a: "Our refurbished equipment is professionally tested, cleaned and certified, and comes with a warranty — a cost-effective, reliable choice for businesses and individuals." },
      { q: "Do you supply hardware in bulk for organisations?", a: "We regularly supply offices, schools, NGOs, banks and government with bulk new or refurbished hardware, complete with configuration and support." },
    ],
    image: "/legacy/laptop.jpg",
  },
  {
    slug: "cloud-solutions-uganda",
    metaTitle: "Cloud Solutions Uganda — Azure, AWS, Google Cloud & Microsoft 365",
    metaDescription:
      "Move to the cloud with Jero-One Technologies. Microsoft Azure, AWS, Google Cloud, Microsoft 365 & Google Workspace migration, backup and management for businesses in Uganda & East Africa.",
    keywords:
      "cloud solutions Uganda, Microsoft Azure Uganda, AWS Uganda, Google Cloud Uganda, Microsoft 365 Uganda, Google Workspace Uganda, cloud migration East Africa, cloud backup Uganda, AI cloud solutions Uganda",
    kicker: "AI & Cloud",
    h1: "Cloud solutions for businesses in Uganda & East Africa.",
    intro:
      "Jero-One Technologies helps businesses across Uganda and East Africa move to and manage the cloud. From Microsoft Azure, AWS and Google Cloud to Microsoft 365 and Google Workspace, we handle migration, backup, security and ongoing management — plus AI solutions that automate and grow your business.",
    serviceType: "Service",
    offerings: [
      "Microsoft Azure, AWS & Google Cloud deployment",
      "Microsoft 365 & Google Workspace setup & migration",
      "Cloud backup, disaster recovery & encryption",
      "AI workflow automation & business assistants",
      "Cloud security, identity & access management",
      "Ongoing cloud management & cost optimisation",
    ],
    why: [
      "Certified partners across major cloud platforms",
      "Secure, compliant migrations with zero data loss",
      "AI & automation expertise for real business results",
      "Local support with global cloud reach",
    ],
    faq: [
      { q: "Which cloud platforms do you support?", a: "We work across Microsoft Azure, Amazon Web Services (AWS), Google Cloud, Microsoft 365 and Google Workspace, choosing the best fit for your business." },
      { q: "Can you migrate our email and files to the cloud?", a: "Yes. We handle secure migration of email, documents and systems to Microsoft 365 or Google Workspace with minimal downtime." },
      { q: "Do you offer cloud backup?", a: "We provide automated, encrypted cloud backup and disaster recovery so your data is always safe and restorable." },
    ],
    image: "/legacy/cloud.jpg",
  },
  {
    slug: "data-center-support-uganda",
    metaTitle: "Data Centre Services & Support in Uganda | Jero-One Technologies",
    metaDescription:
      "Data centre design, deployment, monitoring and support in Uganda & East Africa. Jero-One Technologies delivers server management, maintenance, backup and 24/7 infrastructure support.",
    keywords:
      "data center Uganda, data centre services Uganda, server support Uganda, data center support East Africa, server management Kampala, infrastructure support Uganda, data centre maintenance Uganda",
    kicker: "Data Centre",
    h1: "Data centre services & support in Uganda & East Africa.",
    intro:
      "Jero-One Technologies designs, deploys and supports data centres and server infrastructure for businesses, banks and government across Uganda and East Africa. From server administration and monitoring to maintenance, backup and priority incident response, we keep your critical infrastructure running around the clock.",
    serviceType: "Service",
    offerings: [
      "Data centre design & deployment",
      "Server administration (Windows Server & Linux)",
      "24/7 monitoring & priority incident response",
      "Preventive maintenance & hardware support",
      "Backup, disaster recovery & business continuity",
      "On-site, off-site & remote data centre support",
    ],
    why: [
      "Hands-on infrastructure expertise since 2016",
      "Proven support for banks, government & enterprise",
      "Managed monitoring with rapid response",
      "On-site and remote coverage across the region",
    ],
    faq: [
      { q: "Do you offer data centre support in Uganda?", a: "Yes. We provide data centre design, server management, monitoring, maintenance and 24/7 support across Uganda and East Africa." },
      { q: "Can you manage our servers remotely?", a: "We offer remote, on-site and off-site support, including proactive monitoring and rapid incident response for your servers and infrastructure." },
      { q: "Do you handle backup and disaster recovery?", a: "Absolutely — we implement backup, replication and disaster-recovery plans to ensure business continuity." },
    ],
    image: "/legacy/server.jpg",
  },
  {
    slug: "networking-project-management-uganda",
    metaTitle: "Networking, IT Installations & Project Management in Uganda | Jero-One",
    metaDescription:
      "Professional networking, structured cabling, IT installations and IT project management in Uganda & East Africa. Jero-One Technologies delivers projects on time, on budget and to spec.",
    keywords:
      "IT project management Uganda, networking Uganda, structured cabling Uganda, IT installation Uganda, network setup Kampala, systems integration Uganda, on-site off-site IT support Uganda, IT project delivery East Africa",
    kicker: "Networking & Projects",
    h1: "Networking, installations & IT project management in Uganda.",
    intro:
      "From office networks to large-scale rollouts, Jero-One Technologies delivers professional networking, installations and IT project management across Uganda and East Africa. Our disciplined, proven process ensures every project — cabling, hardware deployment, systems integration — is delivered on time, on budget and to spec.",
    serviceType: "Service",
    offerings: [
      "Network design, setup & structured cabling",
      "Hardware rollouts & site installations",
      "Systems integration & migration",
      "IT project planning & management (proven 10-step process)",
      "On-site, off-site & remote support",
      "Maintenance contracts & SLAs",
    ],
    why: [
      "Proven project delivery methodology",
      "Certified engineers & field teams",
      "On-time, on-budget, to-spec delivery",
      "Trusted by enterprise & government clients",
    ],
    faq: [
      { q: "Do you manage IT projects end-to-end?", a: "Yes. We plan, implement and manage IT projects from start to finish using a disciplined 10-step process, delivering on time and on budget." },
      { q: "Can you set up our office network?", a: "We design and install complete networks — cabling, routers, switches, Wi-Fi, LAN/WAN and security — for offices of any size." },
      { q: "Do you offer on-site support?", a: "We provide on-site, off-site and remote support across Uganda and East Africa, with maintenance contracts and SLAs available." },
    ],
    image: "/legacy/switch.jpg",
  },
  {
    slug: "cctv-security-uganda",
    metaTitle: "CCTV Cameras & Security Systems in Uganda | Jero-One Technologies",
    metaDescription:
      "CCTV supply and installation in Uganda — Hikvision, Dahua & Axis cameras, NVR/DVR, remote monitoring, access control and network security across Uganda & East Africa.",
    keywords:
      "CCTV Uganda, CCTV installation Kampala, security cameras Uganda, Hikvision Uganda, Dahua cameras Uganda, access control Uganda, surveillance systems Uganda, network security Uganda, firewall Uganda",
    kicker: "Security & Surveillance",
    h1: "CCTV cameras & security systems in Uganda & East Africa.",
    intro:
      "Protect your business with Jero-One Technologies. We supply and install CCTV surveillance, access control and network security systems across Uganda and East Africa — using trusted Hikvision, Dahua and Axis hardware, with remote mobile monitoring, NVR/DVR storage and ongoing maintenance.",
    serviceType: "Service",
    offerings: [
      "HD & IP CCTV camera supply and installation",
      "NVR/DVR storage & remote mobile monitoring",
      "Access control & door entry systems",
      "Network firewalls & perimeter security",
      "Security audits & maintenance",
      "Backup power (UPS) protection",
    ],
    why: [
      "Trusted brands: Hikvision, Dahua, Axis",
      "Professional installation & remote monitoring",
      "Integrated security + network expertise",
      "Local maintenance & support",
    ],
    faq: [
      { q: "Do you install CCTV cameras in Uganda?", a: "Yes — we supply and install HD and IP CCTV systems with NVR/DVR and remote mobile monitoring across Uganda and East Africa." },
      { q: "Can I view my cameras remotely?", a: "Yes. Our systems include secure remote viewing from your phone or computer, anywhere in the world." },
      { q: "Do you offer access control and network security?", a: "We install access control, door-entry systems, firewalls and network security to protect both your premises and your data." },
    ],
    image: "/legacy/security.jpg",
  },
  {
    "slug": "custom-software-app-development-kampala-uganda",
    "metaTitle": "Custom Software & App Development Kampala | Jero-One",
    "metaDescription": "Custom software, mobile apps and business automation in Kampala, Uganda: offline-first systems, web portals, mobile money integration and support.",
    "keywords": "software development Kampala, custom software Uganda, app development Kampala, mobile app developers Uganda, business automation Uganda, offline-first systems Uganda, web portal development Kampala",
    "kicker": "Software & App Development · Kampala",
    "h1": "Custom Software & App Development in Kampala, Uganda.",
    "intro": "Jero-One Technologies designs and builds business software that fits how Ugandan organisations really work: offline-first systems for unreliable connectivity, mobile apps with MTN and Airtel mobile money, and automation tools that replace spreadsheets and paperwork for SMEs, SACCOs, schools, NGOs and government.",
    "serviceType": "Custom Software Development",
    "offerings": [
      "Business automation & workflow systems",
      "Android, iOS and cross-platform mobile apps",
      "Offline-first enterprise systems that sync when online",
      "Web portals, dashboards & customer self-service",
      "Mobile money (MTN MoMo, Airtel Money), Pesapal & card payment integration",
      "SMS/USSD integration, reporting and data migration"
    ],
    "why": [
      "NITA-U certified IT provider (CCL2)",
      "Global engineering team since 2009 with local Kampala delivery",
      "Fixed-scope quotations and agile milestones",
      "Hosting, security, training and support after go-live"
    ],
    "process": [
      {
        "t": "Discovery workshop",
        "d": "We map your processes, users, reports and integrations, then agree scope, budget and timeline."
      },
      {
        "t": "Design & prototype",
        "d": "Clickable screens you can test with staff before any code is written."
      },
      {
        "t": "Build & test",
        "d": "Agile sprints with demos every two weeks, security and offline testing on real devices."
      },
      {
        "t": "Launch & support",
        "d": "Data migration, user training, hosting and a support plan so the system keeps running."
      }
    ],
    "faq": [
      {
        "q": "How much does custom software cost in Uganda?",
        "a": "It depends on features, users and integrations. Simple business apps start small, while multi-branch enterprise systems are larger projects. After a free discovery call we send a fixed quotation in UGX or USD."
      },
      {
        "q": "Can the system work without internet?",
        "a": "Yes. We build offline-first systems that keep working during outages and sync automatically when the connection returns, which suits upcountry branches and field teams."
      },
      {
        "q": "Can you integrate mobile money?",
        "a": "Yes: MTN Mobile Money, Airtel Money, Pesapal, card payments, SMS and USSD can all be integrated."
      },
      {
        "q": "Who owns the source code?",
        "a": "You do. On final payment the source code, documentation and hosting accounts are handed over to your organisation."
      }
    ],
    "image": "/website-assets/images/svc-web-900x600.jpg"
  },
  {
    "slug": "erp-enterprise-systems-uganda",
    "metaTitle": "ERP Systems Uganda: Microsoft Dynamics & SAP | Jero-One",
    "metaDescription": "ERP implementation in Uganda: Microsoft Dynamics 365, SAP Business One and custom ERP for banks, SACCOs, government, NGOs and manufacturers in Kampala.",
    "keywords": "ERP Uganda, ERP implementation Kampala, Microsoft Dynamics 365 Uganda, SAP Business One Uganda, enterprise systems Uganda, accounting software Kampala, ERP for NGOs Uganda, ERP for SACCOs Uganda",
    "kicker": "ERP & Enterprise Systems · Uganda",
    "h1": "ERP & Enterprise Systems in Uganda: Microsoft Dynamics, SAP & Custom ERP.",
    "intro": "Jero-One Technologies implements, integrates and supports enterprise resource planning for banks, SACCOs, government entities, NGOs, manufacturers and distributors in Kampala and across Uganda, connecting finance, procurement, inventory, HR/payroll and reporting in one system with URA-ready reporting.",
    "serviceType": "ERP Implementation",
    "offerings": [
      "Microsoft Dynamics 365 Business Central & Finance",
      "SAP Business One implementation & support",
      "Custom ERP modules for unique workflows",
      "Finance, procurement, inventory, HR & payroll",
      "Donor/grant and project accounting for NGOs",
      "Integrations with banks, mobile money, URA EFRIS & existing systems"
    ],
    "why": [
      "NITA-U certified IT provider (CCL2)",
      "Experience with financial institutions, government & NGOs",
      "Data migration, training and change management included",
      "Cloud or on-premise deployment with local support"
    ],
    "process": [
      {
        "t": "Requirements & fit-gap",
        "d": "We review your processes and choose Dynamics, SAP or a custom ERP based on fit, licensing and budget."
      },
      {
        "t": "Configure & integrate",
        "d": "Chart of accounts, workflows, approvals, reports and integrations set up for your organisation."
      },
      {
        "t": "Migrate & train",
        "d": "Clean data migration, end-user and admin training, and parallel runs before cut-over."
      },
      {
        "t": "Go-live & optimise",
        "d": "Hyper-care support at launch, then a managed support contract and continuous improvements."
      }
    ],
    "faq": [
      {
        "q": "Which ERP is best for a Ugandan business?",
        "a": "Mid-sized companies often fit Microsoft Dynamics 365 Business Central or SAP Business One; organisations with unique workflows may need custom modules. We recommend the option after a free assessment."
      },
      {
        "q": "Does the ERP support URA EFRIS?",
        "a": "Yes, we integrate ERP invoicing with URA EFRIS so e-receipts and invoices are fiscalised automatically."
      },
      {
        "q": "How long does an ERP implementation take?",
        "a": "Typically 6–16 weeks depending on modules, branches and data migration."
      },
      {
        "q": "Do you support NGOs and donor reporting?",
        "a": "Yes: grant, project and donor accounting with multi-currency (UGX/USD/EUR) reporting."
      }
    ],
    "image": "/website-assets/images/svc-consulting-900x600.jpg"
  },
  {
    "slug": "managed-it-services-data-center-kampala",
    "metaTitle": "Managed IT Services & Data Center Kampala | Jero-One",
    "metaDescription": "Managed IT services in Kampala & Entebbe: network setup, data center design, server racks, hardware supply, 24/7 security monitoring and IT support contracts.",
    "keywords": "managed IT services Kampala, IT support Kampala, data center design Uganda, server room setup Kampala, network installation Uganda, 24/7 security monitoring Uganda, IT outsourcing Uganda, hardware supply Kampala",
    "kicker": "Managed IT & Infrastructure · Kampala",
    "h1": "Managed IT Services & Data Center Solutions in Kampala.",
    "intro": "Jero-One Technologies runs IT end-to-end for organisations in Kampala, Entebbe and across Uganda: network setup, server rooms and data centres, genuine hardware supply, and 24/7 monitoring and helpdesk support under one predictable monthly contract.",
    "serviceType": "Managed IT Services",
    "offerings": [
      "Network design, structured cabling, fibre & Wi-Fi",
      "Data center & server room design: racks, cooling, UPS, power",
      "Genuine hardware supply: HP, Dell, Lenovo, Cisco, APC",
      "24/7 network & security monitoring with alerting",
      "Helpdesk, on-site support & preventive maintenance",
      "Backup, disaster recovery & Microsoft 365 management"
    ],
    "why": [
      "NITA-U certified IT provider (CCL2)",
      "One accountable partner for supply, installation & support",
      "Clear SLAs with response times for Kampala & Entebbe",
      "Global standards since 2009, local engineers since 2016"
    ],
    "process": [
      {
        "t": "IT health check",
        "d": "We audit your network, servers, security and devices and give you a prioritised report."
      },
      {
        "t": "Design & supply",
        "d": "Right-sized infrastructure with genuine equipment, warranties and a clear quotation."
      },
      {
        "t": "Install & document",
        "d": "Professional installation, labelling and full documentation of your environment."
      },
      {
        "t": "Monitor & support",
        "d": "24/7 monitoring, helpdesk and monthly reports under a fixed-price SLA."
      }
    ],
    "faq": [
      {
        "q": "What do managed IT services cost in Kampala?",
        "a": "Pricing is per user or per device per month, depending on support hours and SLA. We provide a fixed monthly quotation after a free IT health check."
      },
      {
        "q": "Can you design a server room or small data center?",
        "a": "Yes: racks, power distribution, UPS, cooling, access control, cabling and monitoring, from single-rack server rooms to multi-rack facilities."
      },
      {
        "q": "Do you provide on-site support outside Kampala?",
        "a": "Yes, with remote support nationwide and scheduled on-site visits upcountry."
      },
      {
        "q": "Do you supply genuine hardware with warranty?",
        "a": "Yes. We supply genuine HP, Dell, Lenovo, Cisco, Ubiquiti, Fortinet and APC equipment with manufacturer warranty."
      }
    ],
    "image": "/website-assets/images/svc-hero-racks-1600x900.jpg"
  },
  {
    "slug": "hospital-systems-pos-biometric-attendance-uganda",
    "metaTitle": "Hospital Systems, POS & Biometric Attendance Uganda | Jero-One",
    "metaDescription": "Hospital management systems, retail POS and biometric attendance in Uganda: offline-ready software, ZKTeco devices, barcode scanners, setup and support.",
    "keywords": "hospital management system Uganda, clinic software Kampala, POS system Uganda, retail POS Kampala, biometric attendance Uganda, ZKTeco Uganda, fingerprint attendance Kampala, pharmacy software Uganda",
    "kicker": "Sector Solutions · Uganda",
    "h1": "Hospital Management, POS & Biometric Attendance Systems in Uganda.",
    "intro": "Jero-One Technologies delivers sector-specific systems for Ugandan hospitals, clinics, pharmacies, supermarkets, retail shops, schools and offices: offline-ready software plus the hardware (biometric terminals, barcode scanners, receipt printers, networks), installed, trained and supported.",
    "serviceType": "Sector-Specific IT Solutions",
    "offerings": [
      "Hospital & clinic management: patients, billing, lab, pharmacy, inventory",
      "Offline-ready systems that keep running during internet outages",
      "Retail & supermarket POS with barcode scanners, receipt printers and stock control",
      "Mobile money & card payments at the till",
      "Biometric attendance & access control (ZKTeco fingerprint/face terminals)",
      "Payroll-ready attendance reports, installation and staff training"
    ],
    "why": [
      "NITA-U certified IT provider (CCL2)",
      "Software and hardware from one supplier",
      "Offline-first design for Ugandan connectivity",
      "Local installation, training and support contracts"
    ],
    "process": [
      {
        "t": "Site visit",
        "d": "We assess your workflows, branches, devices and network needs."
      },
      {
        "t": "Configure",
        "d": "Software set up with your services, prices, products, staff and shifts."
      },
      {
        "t": "Install hardware",
        "d": "Biometric terminals, POS terminals, scanners, printers and networking installed and tested."
      },
      {
        "t": "Train & support",
        "d": "Hands-on staff training, go-live support and an ongoing maintenance plan."
      }
    ],
    "faq": [
      {
        "q": "Does the hospital system work offline?",
        "a": "Yes. Our hospital and POS deployments are offline-ready and sync when internet returns, so patient care and sales are never interrupted."
      },
      {
        "q": "Which biometric attendance devices do you install?",
        "a": "We supply and install ZKTeco fingerprint, face and card terminals, connected to attendance software with payroll-ready reports."
      },
      {
        "q": "Can the POS accept mobile money?",
        "a": "Yes: MTN Mobile Money, Airtel Money and card payments can be integrated at the till."
      },
      {
        "q": "Do you supply POS hardware?",
        "a": "Yes: barcode scanners, receipt printers, cash drawers, touch terminals and the network to connect them. See our online shop or request a quote."
      }
    ],
    "image": "/website-assets/images/lpo-barcode-scanner-1000x760.jpg"
  },
];

export const getLanding = (slug) => LANDINGS.find((l) => l.slug === slug);
